import { qdfoodApi } from './constant';
import { IResponse } from '@type/response';
import { IFilter } from '@type/param';
import { IProductCustomPrice } from '@features/profile/ProductPriceTable';
import { IFilterProductPrice } from '@type/productPrice';

const PRODUCT_PRICE_URL = {
  urlGetList: `/product-price/web-user`,
  urlExportProductPrice: `/product-price/export`,
};

export default class productPriceApi {
  static getListPagination = (params: IFilter<IFilterProductPrice>) =>
    qdfoodApi().get<IResponse<IProductCustomPrice>>(PRODUCT_PRICE_URL.urlGetList, {
      params,
    });

  static exportProductPrice = (params: { userId: string }) =>
    qdfoodApi().get<Blob>(PRODUCT_PRICE_URL.urlExportProductPrice, {
      params,
      responseType: 'blob',
    });
}
